import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import { applyLocationBoxLayout } from "../../location/LocationMarker";
import { applyCharacterMarkerLayout } from "../../marker/CharacterMarkerLayout/apply";
import { applyPovIndicator } from "../../marker/PovIndicator/apply";
import type { TimelineViewTransform } from "../../view/ViewTransform/transform";
import type { TimelineLayoutFrame } from "./frame";

/** Character markers + location boxes for chapters without a prebuilt board. */
export function applyLayoutTimelineOverlays(
  characterRoot: HTMLElement,
  locationRoot: HTMLElement,
  layout: BookTimelineLayout,
  frame: TimelineLayoutFrame,
  view: TimelineViewTransform,
): void {
  applyCharacterMarkerLayout(
    characterRoot,
    layout,
    frame.playheadMs,
    frame.viewportWidth,
  );
  applyPovIndicator(
    characterRoot,
    layout,
    frame.playheadMs,
    frame.viewportWidth,
  );
  applyLocationBoxLayout(
    locationRoot,
    layout,
    frame.playheadMs,
    frame.viewportWidth,
    frame.viewportHeight,
    view,
  );
}
